if (document.querySelector(".popup-trigger")) {
  const popupTrigger = document.querySelectorAll(".popup-trigger"),
    popup = document.querySelector(".worthington__popup"),
    popupClose = document.querySelector(".worthington__popup--close");

  popupTrigger.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      popup.classList.add("active");
    });
  });

  popupClose.addEventListener("click", (e) => {
    e.preventDefault();
    popup.classList.remove("active");
  });
}
